module.exports = __webpack_public_path__ + "img/eat_out_05.7e57ba3c.jpg";